/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Agreed_ColumnInputs */

const en_admin_statistics_agreed_column = /** @type {(inputs: Admin_Statistics_Agreed_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agreed`)
};

const de_admin_statistics_agreed_column = /** @type {(inputs: Admin_Statistics_Agreed_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbart`)
};

/**
* | output |
* | --- |
* | "Agreed" |
*
* @param {Admin_Statistics_Agreed_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_agreed_column = /** @type {((inputs?: Admin_Statistics_Agreed_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Agreed_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_agreed_column(inputs)
	return en_admin_statistics_agreed_column(inputs)
});